<template>
  <div class="container">



    <div class="row">
      <div class="col 2-col">
        <h2 id="topography">3. Topography</h2>
      </div>
    </div>
    <div class="row">
      <div class="col col-8">
        <ImageMap 
          title="Elevation and Main Peaks" 
          v-bind:images="[{title:'test',source:'/mountain_topo/Elevation.png'}]" 
          v-bind:location="location"
          v-bind:factsheet="factsheet" 
          v-bind:loaded="loaded"
          attribution="Data: MERIT DEM.">
        </ImageMap>
      </div>


      <div class="col col-4">

        <Figure 
          title="Elevation Histogram" 
          src="mountain_topo/ElevationHistogram.svg"
          label="Histogram of Elevation in the Mountain Range." 
          attribution="Data: MERIT DEM"

          v-bind:location="location"
          v-bind:factsheet="factsheet" 
          v-bind:loaded="loaded"
          >
        </Figure>


      
        <table class="table table-sm">
          <caption>Highest Peaks (Top 10)</caption>
          <tr>
            <th>Name</th><th>Elevation (m)</th>
          </tr>
          <tr v-for="peak in factsheet.data.mountain_topo.mountain_peaks.slice(0, 10)">
            <td>{{peak.name}}</td>
            <td>{{peak.elevation}}m</td>
          </tr>
        </table>




      </div>

    </div>

    <div class="row">
      <div class="col col-6">
        <ImageMap 
          title="Slope" 
          v-bind:images="[{title:'test',source:'/mountain_topo/Slope.png'}]" 
          v-bind:location="location"
          v-bind:factsheet="factsheet" 
          v-bind:loaded="loaded"
          attribution="Data: MERIT DEM.">
        </ImageMap>
      </div>
      <div class="col col-6">
        <ImageMap 
          title="Topographic Wetness Index (TWI)" 
          v-bind:images="[{title:'test',source:'/mountain_topo/Wetness.png'}]" 
          v-bind:location="location"
          v-bind:factsheet="factsheet" 
          v-bind:loaded="loaded"
          attribution="Data: MERIT DEM.">
        </ImageMap>
      </div>
    </div>

    


  </div>
</template>

<script>
    /* eslint-disable */
    import ImageMap from '@/components/factsheet/maps/ImageMap.vue'
    import Figure from '@/components/factsheet/Figure.vue'

    import _ from 'lodash';

    export default {
        name: 'Topography',
        components: { ImageMap, Figure },
        props: ['location', 'factsheet', 'loaded'],
        data() {
            return {
            }
        },
        created() {
        },
        computed: {
        },
        mounted() {
        },
        filters: {
          percent: function (value) {
            return value.toFixed(1)+'%'
          }
        },
        methods: {
          urlFor(asset) {
            return process.env.VUE_APP_API+'/api/data/factsheet/'+this.factsheet.info.identifier+'/data/'+asset;
          },
          andList(list, attr, attrpercent) {
            var ret = ""
            for(var i=0; i<list.length;i++) {
              var percent = attrpercent ? ' ('+list[i][attrpercent]+'%)' : ''
              if (list.length == 1) {
                return list[i][attr]+percent
              }
              if(i == list.length-1) {
                ret += " and "+list[i][attr]+percent
              } else {
                ret += list[i][attr]+percent+", "
              }
            }
            return ret
          }
        }
    }
</script>

<style>
div.map {
    width:100%;
    height:450px;
    display:block;
}
</style>

<style scoped>

caption {
  caption-side: top;
  font-weight:bold;
  font-size:1em;
  padding:5px;
  color:rgb(33, 37, 41);
  padding-left:0px;
}
table {
   font-size:0.75em;
}
table th, table td {
  padding-left:0px;
}

</style>